import axios from '@/libs/api.request'

/**
 * 获取用户信息
 */
export const getUserInfo = (u_token) => {
    const data = {
        "u_token": u_token
    }
    return axios.request({
        url: '/api/admin/getUserInfo',
        data,
        method: 'post'
    })
}

/**
 * 获取菜单数据
 */
export const getMenuData = () => {
    return axios.request({
        url: '/api/admin/menu/getMenuData',
        method: 'post'
    })
}
export const getBtns = (menu_id) => {
    const data = {
        "menu_id": menu_id
    }
    return axios.request({
        url: '/api/admin/menu/getBtn',
        data,
        method: 'post'
    })
}

/**
 * 获取枚举数据
 */
export const getEnuData = (names) => {
    let e_str = null;
    for (let i = 0; i < names.length; i++) {
        if (e_str === null) {
            e_str = names[i];
        } else {
            e_str += "," + names[i];
        }
    }
    const data = {
        "names": e_str
    }
    return axios.request({
        url: '/api/admin/enu/getEnuList',
        data,
        method: 'post'
    })
}

/**
 * 获取列表数据
 */
export const getListData = (_url, data) => {
    return axios.request({
        url: _url,
        data,
        method: 'post'
    })
}

/**
 * 删除数据
 */
export const delData = (config) => {
    let data = config.data;
    return axios.request({
        url: config.url,
        data,
        method: 'post'
    })
}

/**
 * 根据ID获取数据
 */
export const getModelById = (config) => {
    let data = {}
    data[config.data.key] = config.data.value;
    return axios.request({
        url: config.url,
        data,
        method: 'post'
    });
}

/**
 * 保存数据
 */
export const saveModel = (config) => {
    let data = config.data;
    return axios.request({
        url: config.url,
        data,
        method: 'post'
    });
}

/**
 * 查重
 */
export const checkExist = (config) => {
    let data = config.data
    return axios.request({
      url: config.url,
      data,
      method: 'post'
    });
}

/**
 * 首页数据
 */
 export const homeData = () => {
    return axios.request({
      url: "/api/admin/statistics/homeData",
      method: 'post'
    });
}